import { render, staticRenderFns } from "./GoalPlan.vue?vue&type=template&id=7749abf0&"
import script from "./GoalPlan.vue?vue&type=script&lang=ts&"
export * from "./GoalPlan.vue?vue&type=script&lang=ts&"
import style0 from "./GoalPlan.vue?vue&type=style&index=0&id=7749abf0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports